import { render } from "./Switch.vue?vue&type=template&id=65f6ea44"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=65f6ea44&lang=scss"
script.render = render

export default script